<div @fadeInAnimation class="food-group-type">
  <div @fadeInAnimation *ngIf="showSelectMenu">
    <p class="text-info-bold-xs mb-xxs opacity-70 mt-xs">Selecciona el platillo</p>
    <nz-select id="selectMenu_{{blockPeriod._id}}" #selectMenu_{{blockPeriod._id}} nzShowSearch
      nzPlaceHolder="Busca un platillo por nombre o descripción" name="foodGroup" #foodGroup="ngModel"
      class="select-meal-plan" [required]="true" [(ngModel)]="blockPeriod.foodGroupId"
      [(nzOpen)]="this.nzSelectMenuOpen" [nzOptionHeightPx]="!isLoadingFirstMenus ? 80 : 80" [nzServerSearch]="true"
      [nzShowSearch]="true" [nzOptionOverflowSize]="6" [nzDropdownRender]="renderTemplate"
      (ngModelChange)="onChooseFoodGroup($event)" (nzOnSearch)="onSearchMenu($event)"
      (nzOpenChange)="onCloseSelect($event)" (nzScrollToBottom)="onLoadMoreFoodGroups()">
      <ng-container *ngIf="!isLoadingFirstMenus; else loadingFirstMenus">
        <nz-option nzCustomContent *ngFor="let menu of (foodGroups$ | async)" [nzValue]="menu?._id"
          [nzLabel]="menu?.name">
          <div class="custom-option-row-menu">
            <div class="ingredient-name truncate">
              <p class=" tw-flex tw-items-center delie-verified tw-w-max text-end" nz-popover="" nzPopoverTitle=""
                [nzPopoverContent]="'Este platillo es original de Dèliè Nutrición'">
                <img *ngIf="menu.official" src="/assets/images/icons/verified-delie.png" alt="" class="icon">
                <span>{{ menu.name }}</span>
              </p>
            </div>
            <div class="macronutrients macros-in-select d-flex justify-content-between">
              <div class="macronutrient">
                <p class="text-info-bold-xs">Calorías</p>
                <p class="text-info text-bold text-small">{{ menu?.nutritionalProperties?.energy_kcal?.toFixed(2) || 0
                  }} kcal</p>
              </div>
              <div class="macronutrient">
                <p class="text-info-bold-xs">Grasas</p>
                <p class="text-info text-bold text-small">{{ menu?.nutritionalProperties?.totalFat_g?.toFixed(2) || 0 }}
                  g</p>
              </div>
              <div class="macronutrient">
                <p class="text-info-bold-xs">H.C</p>
                <p class="text-info text-bold text-small">{{ menu?.nutritionalProperties?.carbohydrate_g?.toFixed(2) ||
                  0 }} g</p>
              </div>
              <div class="macronutrient">
                <p class="text-info-bold-xs">Proteínas</p>
                <p class="text-info text-bold text-small">{{ menu?.nutritionalProperties?.protein_g?.toFixed(2) || 0 }}
                  g</p>
              </div>
              <div class="macronutrient">
                <p class="text-info-bold-xs">Fibra</p>
                <p class="text-info text-bold text-small">{{ menu?.nutritionalProperties?.dietaryFiber_g?.toFixed(2) ||
                  0 }} g</p>
              </div>
            </div>
            <nz-divider style="margin: 10px 0 0 0;"></nz-divider>
          </div>
        </nz-option>
      </ng-container>
      <ng-template #loadingFirstMenus>
        <nz-option nzCustomContent [nzDisabled]="true">
          <div class="tw-h-4">
            <nz-spin class="mt-xlg mb-xlg"></nz-spin>
          </div>
        </nz-option>
      </ng-template>
    </nz-select>
    <ng-template #renderTemplate>
      <nz-spin class="tw-h-0.5 mt-sm mb-sm" *ngIf="isLoadingMenus"></nz-spin>
    </ng-template>
    <app-message-field [field]="foodGroup"></app-message-field>
  </div>
  <p class="text-info-bold-xs mb-xxs opacity-70 mt-xs" *ngIf="blockPeriod.foodGroup">Nombre del platillo</p>
  <p class="text-info" *ngIf="blockPeriod.foodGroup">
    <input type="text" nz-input [(ngModel)]="blockPeriod.foodGroupTitle">
  </p>
  <div class="add-menu d-flex align-items-center select-meal-plan mt-sm" *ngIf="!showSelectMenu" @fadeInAnimation
    (click)="onOpenSelectableFoodGroups()">
    <i nz-icon nzType="plus" nzTheme="outline" class="mr-xxs"></i>
    <p class="text-info">Agrega un platillo al tiempo de comida</p>
  </div>

  <ul class="ingredient-list ml-xs mt-md" *ngIf="blockPeriod.foodGroup && blockPeriod.ingredients" @fadeInAnimation
    [class.blocked]="showSelectIngredients">
    <!--se muestran los ingredientes del platillo-->
    <div *ngFor="let ingredient of blockPeriod.ingredients; index as i" class="ingredient-item">
      <li @fadeInAnimation class="text-info d-flex" (click)="onSetIngredientToEdit(ingredient)">
        <span [class.tw-text-orange-500]="ingredient.isDislike && !ingredient.isAllergic"
          [class.tw-text-red-500]="ingredient.isAllergic">
          {{ ingredient.ingredientName }}. {{ ingredient.units.toFixed(2) }} {{ ingredient.units > 1 ?
          (ingredient.measure.namePlural_es ||
          ingredient.measure.namePlural) : (ingredient.measure.name_es || ingredient.measure.name) }}.
        </span>
        <img loading="lazy" class="icon-edit-ingredient" src="./../../../assets/images/icons/icons8-lapiz-100.png"
          alt="">
      </li>
      <div @fadeInAnimation
        *ngIf="ingredient.ingredientId === this.blockPeriod.ingredientToEdit?.ingredientId && !showSelectIngredients"
        class="tw-w-full d-flex mb-md" style="gap: 1rem">
        <button (click)="onShowFormIngredient()" nz-button nzType="default" class="btn-default">
          <i nz-icon nzType="edit" nzTheme="outline" *ngIf="!loadingIngredient"></i>
          <i nz-icon nzType="loading" nzTheme="outline" *ngIf="loadingIngredient"></i>
          Editar
        </button>
        <button (click)="onRemoveIngredient(ingredient)" nz-button nzType="default" class="btn-default">
          <i nz-icon nzType="delete" nzTheme="outline"></i>
          Eliminar
        </button>
      </div>
    </div>
  </ul>

  <div class="add-menu d-flex align-items-center mb-sm" *ngIf="blockPeriod.foodGroup && !showSelectIngredients"
    (click)="this.blockPeriod.ingredientToEdit= null; onShowFormIngredient()">
    <i nz-icon nzType="plus" nzTheme="outline" class="mr-xxs"></i>
    <p class="text-info">Añadir un ingrediente</p>
  </div>
  <div *ngIf="this.blockPeriod.ingredients | hasAnyAllergicIngredient"
    class="mb-sm tw-bg-red-50 tw-rounded tw-text-red-500 tw-p-4 tw-w-full">
    <p>Hemos detectado que el paciente es alérgico a los alimentos marcados en color rojo.</p>
  </div>
  <div *ngIf="this.blockPeriod.ingredients | hasAnyDislikeIngredient"
    class="mb-sm tw-bg-orange-50 tw-rounded tw-text-orange-500 tw-p-4 tw-w-full">
    <p>Hemos detectado que al paciente no le gustan los alimentos marcados en color naranja.</p>
  </div>
  <div *ngIf="showSelectIngredients">
    <app-form-ingredient [ingredient]="this.blockPeriod.ingredientToEdit" [hasCategoryFilter]="true"
      [hasIngredientName]="true" [hasNutritionalProperties]="true" [hasMeasurementUnit]="true" [hasUnits]="true"
      [hasActionButtons]="true" [showForm]="true" [mealPlanType]="mealPlanType" (save)="onEmitSaveIngredient($event)"
      (cancel)="onCancelEditIngredient()"></app-form-ingredient>
  </div>

  <p class="text-info-bold-xs mb-xxs opacity-70" *ngIf="blockPeriod.foodGroup">Descripción del platillo</p>
  <p class="text-info" *ngIf="blockPeriod.foodGroup">
    <textarea *ngIf="blockPeriod.type === blockPeriodTypeEnum.FOOD_GROUP" nz-input
      [nzAutosize]="{ minRows: 2, maxRows: 6 }" [(ngModel)]="blockPeriod.text" placeholder="Descripción"></textarea>
  </p>
  <div class="line-divider mt-xs mb-md" *ngIf="blockPeriod.foodGroup" @fadeInAnimation></div>
  <div class="macronutrients d-flex justify-content-between mb-md" *ngIf="blockPeriod.foodGroup" @fadeInAnimation>
    <div class="macronutrient">
      <p class="text-info-bold-xs mb-xxs opacity-70">Calorías</p>
      <p class="text-info text-bold">{{ blockPeriod?.nutritionalProperties?.energy_kcal?.toFixed(2) || 0 }} kcal</p>
    </div>
    <div class="macronutrient">
      <p class="text-info-bold-xs mb-xxs opacity-70">Grasas</p>
      <p class="text-info text-bold">{{ blockPeriod?.nutritionalProperties?.totalFat_g?.toFixed(2) || 0 }} g</p>
    </div>
    <div class="macronutrient">
      <p class="text-info-bold-xs mb-xxs opacity-70">Carbohidratos</p>
      <p class="text-info text-bold">{{ blockPeriod?.nutritionalProperties?.carbohydrate_g?.toFixed(2) || 0 }} g</p>
    </div>
    <div class="macronutrient">
      <p class="text-info-bold-xs mb-xxs opacity-70">Proteínas</p>
      <p class="text-info text-bold">{{ blockPeriod?.nutritionalProperties?.protein_g?.toFixed(2) || 0 }} g</p>
    </div>
    <div class="macronutrient">
      <p class="text-info-bold-xs mb-xxs opacity-70">Fibra</p>
      <p class="text-info text-bold">{{ blockPeriod?.nutritionalProperties?.dietaryFiber_g?.toFixed(2) || 0 }} g</p>
    </div>
  </div>
  <p class="text-info-bold-xs mb-xxs mt-md opacity-70" *ngIf="blockPeriod.foodGroup">Tags</p>
  <p class="d-flex" *ngIf="blockPeriod.foodGroup">
    <span class="tag-ingredient ml-none tag-ingredient-red" *ngFor="let tag of blockPeriod.foodGroup.tags; index as i"
      [class.mr-xs]="i
        <blockPeriod.foodGroup.tags.length">
      {{ tag.name }}
    </span>
  </p>
</div>